module.exports = __webpack_public_path__ + "img/lecturerImg1.c3c9ae11.png";